export const printDriver = (content) => {
  // Create an iframe element for printing
  const iframe = document.createElement('iframe')
  iframe.style.position = 'absolute'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = 'none'

  document.body.appendChild(iframe)

  // Access the iframe's document for writing the content
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(content)
  doc.close()

  // Wait for images to load before printing
  const images = doc.querySelectorAll('img')
  const imagePromises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve()
    return new Promise((resolve) => {
      img.onload = resolve
      img.onerror = resolve
    })
  })

  Promise.all(imagePromises).then(() => {
    // Small delay to ensure styles are applied
    setTimeout(() => {
      iframe.contentWindow.focus()
      iframe.contentWindow.print()

      // Clean up by removing the iframe after printing
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 1000)
    }, 500)
  })
}
